import React from "react"
import PropTypes from "prop-types"
import Loadable from "react-loadable"

import { Switch, Route, Redirect } from "react-router-dom"

import { loadingAnimationVariants } from "constants/internal"
import Loading from "lib/views/Loading/Loading"

import { routesApp } from "./helpers"

const NotFound = Loadable({
    loader: () =>
        import(/* webpackChunkName: "not-found" */ "lib/views/NotFound"),
    loading: () => <Loading variant={loadingAnimationVariants.secondary} />,
})
const RoutesEditor = Loadable({
    loader: () => import(/* webpackChunkName: "editor" */ "App/RoutesEditor"),
    loading: () => <Loading variant={loadingAnimationVariants.secondary} />,
})
const RoutesPlayer = Loadable({
    loader: () => import(/* webpackChunkName: "player" */ "App/RoutesPlayer"),
    loading: () => <Loading variant={loadingAnimationVariants.secondary} />,
})
const RoutesPreview = Loadable({
    loader: () => import(/* webpackChunkName: "preview" */ "App/RoutesPreview"),
    loading: () => <Loading variant={loadingAnimationVariants.secondary} />,
})

const RoutesApp = ({ match: { path: routePath } }) => {
    const path = routePath === "/" ? "" : routePath

    return (
        <Switch>
            {/* Editor Routes */}
            <Route path={path + routesApp.editor} component={RoutesEditor} />

            {/* Journey Preview Routes */}
            <Route path={path + routesApp.preview} component={RoutesPreview} />

            {/* Company Player main Route */}
            <Route path={path} component={RoutesPlayer} />

            {/* Redirect index to courses as the main entry point. */}
            <Route path="/" render={() => <Redirect to="/roles" />} />

            {/* Default error page */}
            <Route component={() => <NotFound withHeader />} />
        </Switch>
    )
}

RoutesApp.propTypes = {
    match: PropTypes.object.isRequired,
}

RoutesApp.defaultProps = {}

export default React.memo(RoutesApp)
